'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _noAuthApiClient = require('hub-http/clients/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _applyDefaults = require('conversations-core/http/applyDefaults');

var _applyDefaults2 = _interopRequireDefault(_applyDefaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  post: function post(url, data) {
    return (0, _applyDefaults2.default)(_noAuthApiClient2.default.post, url, data);
  },
  put: function put(url, data) {
    return (0, _applyDefaults2.default)(_noAuthApiClient2.default.put, url, data);
  },
  get: function get(url, data) {
    return (0, _applyDefaults2.default)(_noAuthApiClient2.default.get, url, data);
  },
  delete: function _delete(url, data) {
    return (0, _applyDefaults2.default)(_noAuthApiClient2.default.delete, url, data);
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/http/noAuthApiClient.js
// module id = 118
// module chunks = 0 1